import { createParser } from 'nuqs';

import { SHIPMENT_GROUPING } from '@/lib/constants';
import { ShipmentGrouping } from '@/lib/models/shipment/types';

export const parseAsShipmentGrouping = createParser<ShipmentGrouping>({
  parse(value) {
    return Object.values(SHIPMENT_GROUPING).find((v) => v === value) || SHIPMENT_GROUPING.NONE;
  },
  serialize(value) {
    return value;
  },
});
